const Footer = () => {
    return (
        <div className={"text-sm pt-8 mb-4"}>
            © Techno-Trade Japan Co., Ltd.
        </div>
    )
}

export default Footer